import { Controller } from "@hotwired/stimulus"
let timer = '';

// Connects to data-controller="modal"
export default class ModalController extends Controller {
    static targets = ["openModal", "passwordshow", "discardPost"]

    connect() {
        this.modal = new bootstrap.Modal(this.element)

        if (this.hasDiscardPostTarget) {
            $(this.discardPostTargets).on('click', function (event) {
                this.submitPost(this.element)
            }.bind(this));
        }

        $('.dismiss-ghost-reminder').on("click", function(){
            $('#shareReminderRecipeModal').hide()
            $('#finishGhostModal').hide()
            let backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
            }
        })
    }

    open() {
        if (!this.modal._isShown) {
            this.modal.show()
        }
    }

    openModalTargetConnected(element) {
        // this.element.setAttribute("data-action", "")
        this.modal = new bootstrap.Modal(this.element)
        this.modal.show();
    }

    close(event) {
        if (event.detail.success && !$(event.target).hasClass('no-dismiss')) {
            this.closeModal()
        }
    }

    closeModal(){
        this.modal.hide()
    }

    userSearch(e) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            e.preventDefault()
            let form = $(e.target).closest('form')
            form[0].requestSubmit()
        }, 500);
    }

    submitPost(e) {
        let truck_modal = document.getElementById('addPostModal')
        const modal = bootstrap.Modal.getInstance(truck_modal);
        modal.show()

        Swal.fire({
            customClass: {
                popup: 'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
                htmlContainer: 'text-black-paint text-white'
            },
            animation: false,
            title: "Discard",
            text: "This can’t be undone and you’ll lose your draft.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Discard"
        }).then((result) => {
            if (result.isConfirmed) {
                globalThis.location.href = '/posts'
            }
        });
    }

  submitEnd(event) {
    setTimeout(() => {
      const ele = event.target;
      if (ele.getAttribute("text").length > 0) event.target.children[0].innerText = ele.getAttribute("text");
      if (ele.dataset.disableValue === "true") ele.classList.add("disabled");
    }, 100);
  }

  refreshFrame() {
    this.element.closest(`#${this.element.dataset.reloadFrame}`).reload()
  }

  formSubmit(event) {
    event.target.form.requestSubmit()
  }
}